import { ChangeDetectionStrategy, Component } from '@angular/core';

@Component({
  selector: 'lp2-private-class-center-header-banner',
  styleUrls: ['./private-class-center-header-banner.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: `
    <div class="header w-100 d-flex justify-content-center">
      <h1 class="title">
        {{ 'progress.privateClasses' | translate }}
      </h1>
    </div>
    <img class="smallStar d-none d-xl-block" src="/images/private-classes/private-class-icon-silver.svg" />
    <div class="d-flex flex-1 w-100 mt-3">
      <ng-content></ng-content>
    </div>
  `,
})
export class PrivateClassCenterHeaderBannerComponent {}



// WEBPACK FOOTER //
// ./ts/app/home/live-class-revamp/private-class-banner/private-class-center-header-banner/private-class-center-header-banner.component.ts